import { render } from "./Add2ReabonnementPage.vue?vue&type=template&id=4196b440&ts=true"
import script from "./Add2ReabonnementPage.vue?vue&type=script&lang=ts"
export * from "./Add2ReabonnementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__